<div class="d-flex flex-column">
  <div class="col-12">
    <ul class="nav nav-pills">
      <li class="nav-item" *ngFor="let item of allMainSideMenuItems">
        <a
          class="nav-link"
          aria-current="page"
          [class.active]="
            router.url.includes(item.routerLink) &&
            !router.url.includes('admin')
          "
          routerLink="{{ item.routerLink }}"
          (click)="menuclose()"
        >
          <div class="d-flex align-items-center justify-content-center img-box">
            <img src="{{ item.svgPath }}" />
          </div>
          {{ item.displayedName | transloco }}
          <span
            *ngIf="item.notificationsCount"
            style="
              margin-left: 2px;
              align-items: center;
              display: flex;
              border-radius: 50px;
              height: 20px;
              background: #fd5812;
            "
            class="badge badge-light"
            >{{ item.notificationsCount }}</span
          >
        </a>
      </li>
      <ng-container *ngIf="crm">
        <li class="nav-item pt-5">CRM</li>
        <li class="nav-item">
          <a
            class="nav-link"
            [class.active]="router.url.includes('/CRM/deals')"
            aria-current="page"
            routerLink="/CRM/deals"
            (click)="menuclose()"
          >
            <div
              class="d-flex align-items-center justify-content-center img-box"
            >
              <img src="assets/icons/sidebar/crm.svg" alt="" />
            </div>
            <div>Deals</div>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            [class.active]="router.url.includes('/CRM/accounts')"
            aria-current="page"
            routerLink="/CRM/accounts"
            (click)="menuclose()"
          >
            <div
              class="d-flex align-items-center justify-content-center img-box"
            >
              <img src="assets/icons/sidebar/crm.svg" alt="" />
            </div>
            <div>Accounts</div>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            [class.active]="router.url.includes('/CRM/contacts')"
            aria-current="page"
            routerLink="/CRM/contacts"
            (click)="menuclose()"
          >
            <div
              class="d-flex align-items-center justify-content-center img-box"
            >
              <img src="assets/icons/sidebar/crm.svg" alt="" />
            </div>
            <div>Contacts</div>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            [class.active]="router.url.includes('/CRM/tasks')"
            aria-current="page"
            routerLink="/CRM/tasks"
            (click)="menuclose()"
          >
            <div
              class="d-flex align-items-center justify-content-center img-box"
            >
              <img src="assets/icons/sidebar/crm.svg" alt="" />
            </div>
            <div>Tasks</div>
          </a>
        </li>
      </ng-container>

      <li *ngIf="allIgniteSideMenuItems.length > 0" class="nav-item pt-5">
        Ignite
      </li>

      <li class="nav-item" *ngFor="let item of allIgniteSideMenuItems">
        <a
          class="nav-link"
          [class.active]="router.url.includes(item.routerLink)"
          aria-current="page"
          routerLink="{{ item.routerLink }}"
          (click)="menuclose()"
        >
          <div class="d-flex align-items-center justify-content-center img-box">
            <img src="{{ item.svgPath }}" />
          </div>
          <div>
            {{ item.displayedName | transloco }}
          </div>
        </a>
      </li>

      <li *ngIf="allAdminSideMenuItems.length > 0" class="nav-item pt-5">
        {{ "adminPanel" | transloco }}
      </li>

      <li class="nav-item" *ngFor="let item of allAdminSideMenuItems">
        <a
          class="nav-link"
          [class.active]="router.url.includes(item.routerLink)"
          aria-current="page"
          routerLink="{{ item.routerLink }}"
          (click)="menuclose()"
        >
          <div class="d-flex align-items-center justify-content-center img-box">
            <img src="{{ item.svgPath }}" />
          </div>
          <div>
            {{ item.displayedName | transloco }}
          </div>
        </a>
      </li>

      <ng-container *ngIf="crm">
        <li class="nav-item pt-5">CRM Admin</li>
        <li class="nav-item">
          <a
            class="nav-link"
            [class.active]="router.url.includes('/CRM/taskTypes')"
            aria-current="page"
            routerLink="/CRM/taskTypes"
            (click)="menuclose()"
          >
            <div
              class="d-flex align-items-center justify-content-center img-box"
            >
              <img src="assets/icons/sidebar/crm.svg" alt="" />
            </div>
            <div>Task Types</div>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            [class.active]="router.url.includes('/CRM/tags')"
            aria-current="page"
            routerLink="/CRM/tags"
            (click)="menuclose()"
          >
            <div
              class="d-flex align-items-center justify-content-center img-box"
            >
              <img src="assets/icons/sidebar/crm.svg" alt="" />
            </div>
            <div>Tags</div>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            [class.active]="router.url.includes('/CRM/lists')"
            aria-current="page"
            routerLink="/CRM/lists"
            (click)="menuclose()"
          >
            <div
              class="d-flex align-items-center justify-content-center img-box"
            >
              <img src="assets/icons/sidebar/crm.svg" alt="" />
            </div>
            <div>Lists</div>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            [class.active]="router.url.includes('/CRM/activities')"
            aria-current="page"
            routerLink="/CRM/activities"
            (click)="menuclose()"
          >
            <div
              class="d-flex align-items-center justify-content-center img-box"
            >
              <img src="assets/icons/sidebar/crm.svg" alt="" />
            </div>
            <div>Activities</div>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            [class.active]="router.url.includes('/CRM/users')"
            aria-current="page"
            routerLink="/CRM/users"
            (click)="menuclose()"
          >
            <div
              class="d-flex align-items-center justify-content-center img-box"
            >
              <img src="assets/icons/sidebar/crm.svg" alt="" />
            </div>
            <div>Users</div>
          </a>
        </li>
      </ng-container>
    </ul>
  </div>
</div>
<div
  *ngIf="tenantsOptions && tenantsOptions.length > 1"
  class="form-floating mb-3"
>
  <p class="ms-2 mb-0 mt-2" style="color: white">
    {{ "activeTenant" | transloco }}
  </p>
  <app-datalist-select
    class=""
    [activeValue]="tenantId"
    [options]="tenantsOptions"
    [clearable]="true"
    (activeValueChange)="setActiveTenant($event)"
    [multiple]="false"
  ></app-datalist-select>
</div>
